<td>
  <span class="flex gap-2 align-items-center"
    ><i class="fas fa-note-sticky"></i> {{ item.title }}</span
  >
</td>
<td>
  <span class="flex gap-2">
    <a
      pButton
      *ngIf="actions.includes('openInAtlas')"
      class="ml-auto p-button-xs"
      pTooltip="Im Atlas anzeigen"
      (click)="openInAtlas(item._id)"
      [rounded]="true"
      icon="fas fa-laptop-code"></a>
    <a
      *ngIf="actions.includes('edit')"
      pButton
      class="p-button-xs"
      (click)="closeParent()"
      [routerLink]="[{ outlets: { bearbeiten: ['bookmark', item._id] } }]"
      [rounded]="true"
      icon="fas fa-pen"></a>
  </span>
</td>
